import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Locations: {
    id: 'label_locations',
    defaultMessage: 'Locations',
  },
  Call: {
    id: 'locations_call',
    defaultMessage: 'Call',
  },
  SendEmail: {
    id: 'locations_send_email',
    defaultMessage: 'Send an e-mail',
  },
  PlanRoute: {
    id: 'locations_route_planner',
    defaultMessage: 'Route planner',
  },
  MoreInformation: {
    id: 'locations_more_information',
    defaultMessage: 'More information',
  },
});
